import React from 'react';

function Logo({ className = "", size = 40 }) {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 100 100" 
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '10px' }}
    >
      <defs>
        <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#16a085', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#1abc9c', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <circle cx="50" cy="50" r="45" fill="url(#logoGrad)"/>
      <path 
        d="M30 45 L45 60 L70 35" 
        stroke="white" 
        strokeWidth="8" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        fill="none"
      />
      <circle cx="50" cy="50" r="45" fill="none" stroke="white" strokeWidth="3" opacity="0.3"/>
    </svg>
  );
}

export default Logo;
